<template>
    <section class="section">
        <div class="container">
            <h1 class="title">vue-ui-table</h1>
            <p class="subtitle">
                A simple demonstration of use with <a href="https://bulma.io/" target="_blank"><strong>Bulma</strong></a>!
            </p>
            <ui-table :items="items" :pagination="pagination">
                <ui-table-column prop="a" header="A" width="100px"></ui-table-column>
                <ui-table-column prop="b" header="B"></ui-table-column>
            </ui-table>
        </div>
    </section>
</template>

<script>
    export default {
        name: "bulma",
        data() {
            return {
                items: [
                    { a: 1, b: 2 },
                    { a: 1, b: 2 },
                    { a: 1, b: 2 },
                    { a: 1, b: 2 },
                    { a: 1, b: 2 },
                    { a: 1, b: 2 }
                ],
                pagination: {
                    page: 1,
                    max: 20
                }
            }
        },
        mounted() {
            this.$uiTable = {
                theme: {
                    classes: {
                        container: "table-container",
                        table: "table",
                        bordered: "is-bordered",
                        striped: "is-striped",
                        dense: "is-narrow",
                        hoverable: "is-hoverable"
                    }
                }
            }
        }
    }
</script>